<div>
    <div *ngIf="plan.transitionTo || plan.templateType === 'TRANSITION'">
       <hr class="{{brand}}-hr my-3"> 
    </div>
    <!-- features -->   
    <div *ngIf="!featuresHidden" class="d-flex flex-column mx-auto pt-1">
        <!-- headline/tag -->
        <div class="gb-body2 gb-color-grey-mid-dark pb-2" *ngIf="plan.featureDisplay === 'CHECKLIST'">
            {{getGenericCopy('myplans.headliner')}}
        </div>
        <div *ngFor="let category of getPlanFeatureCategories(); let last=last">
            <shop-title-content-card 
            [category]="isBundleProduct ? category : undefined" 
            [featuresToShow]="this.plan.featureDisplay === 'CHECKLIST' ? getFeatures(category) : getDescription(category)" 
            [tableType]="'myPlans'" 
            [theme]="brand" 
            [featureDisplay]="plan.featureDisplay ?? 'SHORT_DESCRIPTION'">
            </shop-title-content-card>
            <div class="gb-body3 py-1">
                <a class="gb-color-grey-mid-dark"
                    (click)="openModal(category)"
                    (keyup.enter)="openModal(category)"
                    trackLink="See Details"
                    trackType="o"
                    [prop15]="'my_plans_see_details' | translate"
                    [prop10]="trackingString('link', [plan.planName, getFeatureCategory(category), 'my_plans_see_details' | translate])"
                    [evar33]="trackingString('link', [plan.planName, getFeatureCategory(category), 'my_plans_see_details' | translate])">
                    <span tabindex="0">{{'my_plans_see_details' | translate}}</span>
                </a>
            </div>
            <webu-data-bar *ngIf="featureHasData(getFeatureCategory(category));" [plan]="plan"></webu-data-bar>
           <hr *ngIf="!last" [class]="getHRClass()">
        </div>
        <div class="gb-body3 heavy" *ngIf="plan.transitionTo">
            <a (click)="toggleFeatures()" class="gb-color-grey-mid-dark">
                <hr class="{{brand}}-hr my-3 mb-4">
                <span tabindex="0" (keyup.enter)="toggleFeatures()">{{'myplans_show_less' | translate}}</span>               
            </a>
        </div>
    </div>
    <div *ngIf="featuresHidden" class="gb-body3 heavy pt-2">
        <a (click)="toggleFeatures()" class="gb-color-grey-mid-dark">            
            <span tabindex="0" (keyup.enter)="toggleFeatures()">{{'myplans_show_more' | translate}}</span>                       
        </a>
    </div>
</div>
